import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Input, Typography, Button, notification, message } from 'antd';
import { MailOutlined, CopyOutlined, UserOutlined } from '@ant-design/icons';

const { Column } = Table;

function Evaluatoredit({ selectedEvaluatee }) {
  const [evaluators, setEvaluators] = useState([]);
  const [changedEvaluators, setChangedEvaluators] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedEvaluatee) {
      getEvaluators(selectedEvaluatee);
    }
  }, [selectedEvaluatee]);

  async function getEvaluators(selectedEvaluatee) {
    try {
      const response = await axios.get(`https://api-back.greatmanagers.org/evaluatorsi/${selectedEvaluatee}`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      console.log('API response data:', response.data);
      response.data.forEach((evaluator, index) => {
        console.log(`Evaluator ${index} fields:`, Object.keys(evaluator));
        console.log(`Evaluator ${index} data:`, evaluator);
      });
      
      // Store original values for tracking changes
      const evaluatorsWithOriginalValues = response.data.map(evaluator => ({
        ...evaluator,
        OldEvaluatorEmail: evaluator.EvaluatorEmail,
        OldName: evaluator.Name
      }));
      
      console.log('Evaluators with original values:', evaluatorsWithOriginalValues);
      setEvaluators(evaluatorsWithOriginalValues);
    } catch (error) {
      console.error('Error fetching evaluators:', error);
    }
  }

  // Create a unique key for each evaluator since there's no EvaluatorID
  const createEvaluatorKey = (evaluator) => {
    return `${evaluator.EvaluateeID}_${evaluator.OldEvaluatorEmail}_${evaluator.OldName || 'noname'}`;
  };

  const updateChangedEvaluators = (changedEvaluator, evaluatorKey) => {
    const existingIndex = changedEvaluators.findIndex(e => e.key === evaluatorKey);
    
    if (existingIndex === -1) {
      setChangedEvaluators([...changedEvaluators, { ...changedEvaluator, key: evaluatorKey }]);
    } else {
      const updatedChangedEvaluators = [...changedEvaluators];
      updatedChangedEvaluators[existingIndex] = { ...changedEvaluator, key: evaluatorKey };
      setChangedEvaluators(updatedChangedEvaluators);
    }
  };

  const handleEmailChange = (index, e) => {
    const updatedEvaluators = [...evaluators];
    updatedEvaluators[index].EvaluatorEmail = e.target.value;
    setEvaluators(updatedEvaluators);

    const evaluator = updatedEvaluators[index];
    const evaluatorKey = createEvaluatorKey(evaluator);
    
    // Track changed evaluator
    const changedEvaluator = {
      EvaluateeID: evaluator.EvaluateeID,
      OldEvaluatorEmail: evaluator.OldEvaluatorEmail,
      OldName: evaluator.OldName,
      NewEvaluatorEmail: e.target.value,
      NewName: evaluator.Name
    };
    updateChangedEvaluators(changedEvaluator, evaluatorKey);
  };

  const handleNameChange = (index, e) => {
    const updatedEvaluators = [...evaluators];
    updatedEvaluators[index].Name = e.target.value;
    setEvaluators(updatedEvaluators);

    const evaluator = updatedEvaluators[index];
    const evaluatorKey = createEvaluatorKey(evaluator);
    
    // Track changed evaluator
    const changedEvaluator = {
      EvaluateeID: evaluator.EvaluateeID,
      OldEvaluatorEmail: evaluator.OldEvaluatorEmail,
      OldName: evaluator.OldName,
      NewEvaluatorEmail: evaluator.EvaluatorEmail,
      NewName: e.target.value
    };
    updateChangedEvaluators(changedEvaluator, evaluatorKey);
  };

  const handleSaveEmails = () => { 
    if (changedEvaluators.length === 0) {
      message.warning('No changes to save');
      return;
    }
    
    setLoading(true);
    console.log('Saving evaluators:', changedEvaluators);
    
    // Remove the 'key' property before sending to backend
    const evaluatorsToSave = changedEvaluators.map(({ key, ...evaluator }) => evaluator);
    
    axios.post('https://api-back.greatmanagers.org/updateevaluatorsz', evaluatorsToSave, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
      }
    })
    .then(response => {
      console.log('Evaluators updated successfully');
      message.success('Evaluators updated successfully!');
      setChangedEvaluators([]);
      // Refresh the data
      getEvaluators(selectedEvaluatee);
    })
    .catch(error => {
      console.error('Error updating evaluators:', error);
      notification.error({
        message: 'Update Error',
        description: 'There was an error updating the evaluators. Please try again.'
      });
    })
    .finally(() => {
      setLoading(false);
    });
  };
  
  return (
    <div>
      {selectedEvaluatee && (
        <div style={{ marginTop: '20px' }}>
          <Table 
            dataSource={evaluators} 
            rowKey={(record) => createEvaluatorKey(record)}
            components={{
              header: {
                cell: (props) => (
                  <th {...props} style={{ backgroundColor: '#F6F7FB' }} />
                ),
              },
            }}
          >
            <Column
              title="Evaluator Email"
              dataIndex="EvaluatorEmail"
              key="EvaluatorEmail"
              render={(text, record, index) => (
                <Input
                  value={text}
                  onChange={(e) => handleEmailChange(index, e)}
                  prefix={<MailOutlined />}
                />
              )}
            />
            <Column
              title="Name"
              dataIndex="Name"
              key="Name"
              render={(text, record, index) => (
                <Input
                  value={text || ''}
                  onChange={(e) => handleNameChange(index, e)}
                  prefix={<UserOutlined />}
                />
              )}
            />
            <Column
              title="Action Control"
              key="actions"
              render={(text, record, index) => (
                <Button
                  type="primary"
                  onClick={handleSaveEmails}
                  loading={loading} 
                  icon={<CopyOutlined 
                    style={{color: '#6D6D6D'}}
                  />}
                  style={{
                    backgroundColor: '#ffffff',
                    borderColor: '#B5B5B5',
                  }}
                >
                  <span style={{
                    color: '#6D6D6D',
                  }}>Save Changes</span>
                </Button>
              )}
            />
          </Table>
        </div>
      )}
    </div>
  );
}

export default Evaluatoredit;